import { createContext, useContext, useMemo, useState } from "react";
import cookieStorage from "../utilities/cookie_storage";

const PermissionsContext = createContext();

const STORAGE_KEY = "rolePermissions";

export const PermissionsProvider = ({ children }) => {
  const [permissions, setPermissions] = useState(() => {
    try {
      // cookieStorage already encrypts/decrypts internally — just parse the JSON
      const saved = cookieStorage.getItem(STORAGE_KEY);
      if (saved) return JSON.parse(saved);

      // Migration: old plain-text localStorage value
      const legacy = localStorage.getItem("rolePermissions");
      if (legacy) {
        const parsed = JSON.parse(legacy);
        cookieStorage.setItem(STORAGE_KEY, JSON.stringify(parsed));
        localStorage.removeItem("rolePermissions");
        return parsed;
      }
    } catch {}
    return {};
  });

  const setRolePermissions = (newPermissions) => {
    if (newPermissions) {
      // cookieStorage handles encryption internally
      cookieStorage.setItem(STORAGE_KEY, JSON.stringify(newPermissions));
    } else {
      cookieStorage.removeItem(STORAGE_KEY);
    }
    setPermissions(newPermissions || {});
  };

  const contextValue = useMemo(
    () => ({ permissions, setRolePermissions }),
    [permissions]
  );

  return (
    <PermissionsContext.Provider value={contextValue}>
      {children}
    </PermissionsContext.Provider>
  );
};

export const usePermissions = () => useContext(PermissionsContext);
